import { ReactElement, useState } from 'react';
import { Button, Loading, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useCalendarContext } from '../../Calendar/Calendar.hook';
import styles from './TemplateModal.module.scss';
import { useAgendaTemplatesContext } from '../../../hooks/agendaTemplateView.hook.ts';
import { useToastContext } from '../../../../../providers/ToastProvider/Toast.hook.ts';
import { eAlertType } from '../../../../../providers/ToastProvider/Toast.enum.ts';

export default function TemplateDeleteModal(): ReactElement {
  const { t } = useTranslation();
  const {
    showDeleteTemplate,
    setShowDeleteTemplate,
    selectedTemplate,
    setSelectedTemplate,
  } = useCalendarContext();
  const { deleteTemplate } = useAgendaTemplatesContext();
  const { addAlert } = useToastContext();

  const [loading, setLoading] = useState<boolean>(false);

  async function deleteTemplateHandler() {
    try {
      setLoading(true);
      if (!selectedTemplate) return;
      await deleteTemplate(selectedTemplate);
    } catch (error) {
      addAlert({
        type: eAlertType.ERROR,
        message: (error as Error).message || 'Error al eliminar la template',
      });
    }
    setLoading(false);
    setShowDeleteTemplate(false);
    setSelectedTemplate(null);
  }

  return (
    <Modal.Legacy
      open={showDeleteTemplate}
      onClickBackdrop={() => setShowDeleteTemplate(!showDeleteTemplate)}
    >
      <div className={styles.TemplateDeleteModal}>
        <div className={styles.TemplateDeleteModal__Image}>
          <img src="/images/agenda/warning.png" className="w-16" />
        </div>
        <div className={styles.TemplateDeleteModal__Title}>
          <strong className="text-2xl">
            {t('agenda/agenda:delete-template')}
          </strong>
        </div>
        <div className={styles.TemplateDeleteModal__Body}>
          <div className="form-control">
            <p>{t('agenda/agenda:delete-template-text-1')}</p>
            <p>{t('agenda/agenda:delete-template-text-2')}</p>
          </div>
        </div>
        <div className={styles.TemplateDeleteModal__ActionContainer}>
          <Button
            variant="outline"
            color="ghost"
            onClick={deleteTemplateHandler}
          >
            {loading ? <Loading /> : t('agenda/agenda:delete-button')}
          </Button>
          <Button
            color="error"
            onClick={() => {
              setShowDeleteTemplate(!showDeleteTemplate);
            }}
          >
            {t('agenda/agenda:cancel-delete')}
          </Button>
        </div>
      </div>
    </Modal.Legacy>
  );
}
